/**
 * StaleBuildNotice (ported from dink-admin DNKADM-0372/0382): a non-blocking snackbar — never a modal — that
 * appears when the server serves a newer build than the one this tab is running,
 * offering a Reload. Reload is the operator's choice; nothing here reloads on its
 * own. Dismissing hides it for a while (see `useStaleBuildCheck`).
 *
 * Anchored bottom-center so it never stacks on the bottom-left toasts, and kept
 * open (no auto-hide) until the operator acts: the situation it reports does not
 * resolve itself. The Reload action is the shared `reloadForNewBuild` (DNKADM-0382 U2)
 * — the same path the Help menu offers, not a second copy.
 */
import { Alert, Button, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { reloadForNewBuild } from './buildCheck';
import { useStaleBuildCheck } from './useStaleBuildCheck';

export function StaleBuildNotice() {
  const { t } = useTranslation();
  const { stale, dismiss } = useStaleBuildCheck();

  return (
    <Snackbar
      open={stale}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={(_event, reason) => {
        // Click-away must not dismiss: the front desk keeps working around it.
        if (reason === 'clickaway') return;
        dismiss();
      }}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <>
            <Button color="inherit" size="small" onClick={reloadForNewBuild}>
              {t('stale.reload')}
            </Button>
            <Button color="inherit" size="small" onClick={dismiss}>
              {t('stale.later')}
            </Button>
          </>
        }
      >
        {t('stale.message')}
      </Alert>
    </Snackbar>
  );
}
